/** Sdílené React Query klíče submodulu Stations (napříč okny `list/` + `detail/`). */

/**
 * Klíč ListPage configu stanic — zároveň prefix React Query klíčů seznamu
 * (`[STATION_LIST_KEY, 'list' | 'stats', …]`). Slouží k invalidaci seznamu po uložení detailu.
 */
export const STATION_LIST_KEY = 'products.stations';
